import moment from 'moment';

export const exportTestResultPdf = (datas, filename) => {
    // let data = JSON.stringify(this.state.users);
  let data_content = '';

  const printWindow = window.open('', '_blank');

  const content = `<tr style="height: 10px">
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-180px"><h6>User Name</h6></th>
                <th className="text-center "><h6>Gender</h6></th>
                <th className="text-center "><h6>Batch</h6></th>
                <th className="text-center "><h6>Exam Date</h6></th>
                <th className="text-center "><h6>Result Reading</h6></th>
                <th className="text-center "><h6>Result Listening</h6></th>
                <th className="text-center "><h6>Total</h6></th>
                <th className="text-center "><h6>Result Blind Test</h6></th>
              </tr>`;

  
  datas.forEach((user, index) => {
    data_content += `<tr>
        <td ><strong>${index + 1}</strong></td>
        <td ><strong>${user.user?.last_name + ' ' + user.user?.first_name}</strong></td>
        <td ><strong>${user.user?.gender_id == 1? "Male" : "Femail"}</strong></td>
        <td ><strong>${user.user?.generation || ""}</strong></td>
        <td ><strong>${moment(user.created_at).format("DD-MMM-YYYY")}</strong></td>
        <td style="width: '300px'">${user.result.reading * 2.5} (${user.result.reading}/${user.result.total_reading})</td>
        <td >${user.result.listen * 2.5} (${user.result.listen}/${user.result.total_listing})</td>
        <td >${(user.result.listen + user.result.reading) * 2.5}</td>
        <td >${user.result.blind_test}/${user.result.total_blind_test}</td>
      <tr>`
  });

  // data_content = JSON.stringify(data_content);
  // data_content = data_content.replace(/(\r\n|\n|\r)/gm, "");

  printWindow.document.write(`
    <html>
      <head>
        <title>Print Preview</title>
        <style>
          @page { 
            size: A4;
            margin: 0mm;
          }
          html,
        body {
            width: 210mm;
            height: 297mm;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }  
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
          }
          .content {
            width: 80%;
            height: 90%;
            padding: 10px;
            box-sizing: border-box;
            font-family: Arial, sans-serif;
          }
           


          #customers {
            font-family: Arial, Helvetica, sans-serif;
            border-collapse: collapse;
            width: 100%;
          }

          #customers td, #customers th {
            border: 1px solid #ddd;
            padding: 8px;
          }

          #customers tr:nth-child(even){background-color: #f2f2f2;}

          #customers tr:hover {background-color: #ddd;}

          #customers th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: center;
            background-color: #48b0f7;
            color: white;
            font-size: 15
          }
           #customers td {
            font-size: 12
          } 
        
            
        </style>
      </head>
      <body>
        <div class="content">
        <div style="text-align: center"> <h3>${filename}</h3> </div> <br />
        <table id="customers">
            <thead>
                ${content}
            </thead>
            <tbody>
              ${data_content}
            </tbody>
          </table>
        </div>
      </body>

       <script>

          window.onload = function() {
            window.print();
          }
          window.onafterprint = function() {
                    window.close();
          };



        </script>
    </html>
  `);

  printWindow.document.close();
  };